import SignIn from "../Components/SignIn";

function Login() {
  return <SignIn />;
}

export default Login;
